import { createCustomEnum } from "./customEnum";

const PayoutMethodTypes = createCustomEnum({
	ACH: {
		value: 1,
		name: "Ach",
		displayName: "ACH",
	},
	DomesticWire: {
		value: 2,
		name: "DomesticWire",
		displayName: "Domestic wire",
	},
	InternationalWire: {
		value: 3,
		name: "InternationalWire",
		displayName: "TransIT",
	},
	Check: {
		value: 4,
		name: "Check",
		displayName: "Check",
	},
	Payroll: {
		value: 5,
		name: "Payroll",
		displayName: "Payroll",
	},
});

export default PayoutMethodTypes;
